const BUSINESS_TYPE_API_REQUEST="BUSINESS_TYPE/API_REQUEST";
const BUSINESS_TYPE_API_SUCCESS="BUSINESS_TYPE/API_SUCCESS";
const BUSINESS_TYPE_API_FAILED="BUSINESS_TYPE/API_FAILED";

export {BUSINESS_TYPE_API_REQUEST, BUSINESS_TYPE_API_SUCCESS, BUSINESS_TYPE_API_FAILED}